import { observable, action, autorun } from 'mobx';
import api from '../api';
import accountStore from './accountStore';
// import routingStore from './routingStore';
import igStore from '~/components/ig/store';
import lineStore from './lineStore';
import Cookies from 'js-cookie';

class SessionChecker {
	INTERVAL = 60000;
	error_count = 0;
	store = null;

  constructor(store) {
  	this.store = store;
	if (process.env.NODE_ENV === 'development'){ return}
	  autorun(() => {
	  	if (this.store.terminalAccess) {
	    	setInterval(() => {
	        this.check();
	    	}, this.INTERVAL);
	    }
    })
  }

  check() {
		return api.checker.get().then(
			action(
				res => {
					if (!res.access) {
          	this.store.clear('TERMINAL');
          }
					if (!res.access) {
              this.error_count++;
          }
          if (this.error_count > 10) {
              this.store.clear('TERMINAL');
          }
				}))
  }
}

export class AppStore {
	//check terminal;

	@action loginTerminal() {
		api.terminal.login().then(
			action(res => {
				if (res.code == 'OK') {
					if (res.result == 1) {
						this.terminalAccess = 1;
						this.cardId = res.result.card;
					}
					else if (res.result == 2) {
						// this.setTerminalError(1, 'Не правильные параметры авторизации');
						console.error('неправильные данные', res);
					} else {
						this.checkTerminal(res.result);
					}
				} else {
					console.error('неправильные данные', res);
				}
			})
		)
		.catch(action(err => {
      console.error('неправильные данные', err);
		}))
	}

	checkTerminal(data) {
		console.log(data)
		return api.terminal.check(data).then(
			action( res => {
				if (res.code == "OK") {
					this.terminalAccess = 1;
				} else {
					console.error('неправильные данные', res);
				}
			})
		)
		.catch(action(err => {
      console.error('неправильные данные', err);
		}))
	}


	// app store
	sessionChecker = null;
	@observable appName = 'ИРМ';
	@observable lang = 'RU';
	@observable terminalAccess = 0;
	@observable slides = null;
	@observable isLoading = false;
	@observable cardReader = false;
	@observable appLoading = false;
	@observable financeData = '';
	@observable currency = '';
	@observable showTopMenu = true;
	@observable history = null;
	@observable cashboxMode = 2;
	@observable cashboxRules = '';
	@observable cashboxId = null;
	@observable currency_id = 2;
	@observable initData = {
		hideHomePage: 0
	};
	@observable error = {
		status: 0,
		text: ''
	};

  @observable isNotificationVisible = {
    movingStatistics: false,
  };

	timerRules = null;
	// navLinks = [
	// 	{ path: '/line' , name: 'Линия', access: 2},
	// 	{ path: '/live' , name: 'Лайв', access: 2},
	// 	{ path: '/results' , name: 'Результаты', access: 1, sub: [
	// 			{ path: '/results/line' , name: 'Результаты', access: 1},
	// 			{ path: '/results/live' , name: 'Результаты Live', access: 1},
	// 		]
	// 	},
	// 	{ path: '/stats' , name: 'Статистика', access: 1},
	// 	{ path: '/toto' , name: 'Тото', access: 1},
	// 	{ path: '/account' , name: 'Личные данные', access: 1, sub: [
	// 			{ path: '/account/bets' , name: 'Ваши ставки', access: 1},
	// 			{ path: '/account/history' , name: 'История', access: 1},
	// 		]
	// 	},
	// 	{ path: '/payout' , name: 'Выплата', access: 1},
	// 	{ path: '/payout' , name: 'Выплата', access: 1},
	// ];

	constructor() {
		this.sessionChecker = new SessionChecker(this);
		this.igStore = igStore;
		this.lineStore = new lineStore(this);
		// autorun(() => {
		// 	console.log(routingStore.location);
		// })
	}

	@action setHistory(history) {
		this.history = history;
	}

	// @computed get links() {
	// 	return this.navLinks.filter( item => item.access === this.access || item.access === 2 )
	// }

	@action initApp() {
		this.getData();
	}

	@action getData() {
		let count = 0;
		return api.data.get().then(
			action(
				res => {
					if (res.code == 'OK') {
						this.terminalAccess = 1;
						this.cardReader = res.card_reader;
						this.cashboxId = res.cashbox_id;
						this.initData.hideHomePage = res.hide_homepage;
						// lineStore.liveSetting = res.live_setting;
						this.lineStore.liveRefreshInterval = res.live_refresh_interval;
						this.lineStore.liveRefreshOne = res.live_refresh_one;
						if (res.access) {
							Cookies.set('user_logged_in', 1);
							accountStore.changePsw = res.change_psw;
							accountStore.access = 1;
							accountStore.isCard = res.is_card;
							accountStore.logout_hash = res.logout_h;
							accountStore.accountSettings.oneClickBetAmount = res.oneclick ? res.oneclick : 0;
							accountStore.login = res.login ? res.login : null;
							accountStore.hideRoutes = res.hide_routes;
							accountStore.init();
							this.currency_id = res.currency_id;
						} else {
							Cookies.set('user_logged_in', 0);
						}
						this.addFinanceData(res.finance_data);
						if (res.lang) this.lang = res.lang;
						if (res.fast_amount) {
							accountStore.fastAmounts.amounts = res.fast_amount.data;
							accountStore.fastAmounts.limits = res.fast_amount.rules;
						}
						this.startCheckCashboxMode();
					} else {
						clearInterval(this.timerRules);
						if (process.env.NODE_ENV === 'development'){return}
						if (window.location.pathname != '/terminal/login') {
							window.location = '/terminal/login';
						}
					}
				}
			)
		)
		.catch(action(err => {
			if (count < 5) {
				this.getData();
			} else {
				this.error.status = 1;
				this.error.text = 'SERVER_TEMPORARILY_DOWN';
			}
    }))
    .finally(action(() => { this.appLoading = true; }));
	}

	@action loadSlider() {
		return api.slides.getIrmBanners().then(
			action((result) => {
				if (result.code == '0') {
					this.slides = result.result;
				}
			}))
      // .catch(action(err => {
      //   this.AppError = err.response && err.response.body && err.response.body.errors;
      //   throw err;
      // }))
      // .finally(action(() => { this.isLoading = true; }));
	}

	@action toggleShowTopMenu(status) {
		this.showTopMenu = status;
	}

	@action addFinanceData(data) {
		if (data) {
			this.financeData = data;
			if (typeof this.currency_id == 'undefined') {
			   this.getCurrency();
			} else {
				this.currency = this.financeData[this.currency_id] ? this.financeData[this.currency_id] : 'undefined';
			}
	  	}
	}

	@action getCurrency() {
		return api.terminal.getCurrency().then(
			action( data => {
				if (data.code === 'OK') {
					this.currency_id = data.result;
					if (this.financeData && (!this.currency || this.currency.id !== this.currency_id)) {
						this.currency = this.financeData[this.currency_id] ? this.financeData[this.currency_id] : 'undefined';
					}
				}})
		);
	}

	// @action enterPhone(phone) {
 //    const number = parseInt(phone.replace(/\D+/g,""));
 //    this.error.status = false;
 //    if (number.toString().length > 0){
 //      this.phone = number;
 //    } else {
 //      this.phone = '';
 //    }
 //  }

	@action clear(type) {
		switch(type) {
			case 'TERMINAL' :
				this.terminalAccess = 0;
				this.access = 0;
				this.logout_hash = '';
				if (!process.env.NODE_ENV === 'development'){
					window.location = '/terminal/login';
				}
				break;
			case 'ACCESS' :
				accountStore.access = 0;
				accountStore.logout_hash = '';
				this.history.push('/');
				break;
		}
  }

  @action startCheckCashboxMode() {
  	this.getCashboxMode();
  	this.timerRules = setInterval(() => {this.getCashboxMode()}, 600000);
  }

  @action getCashboxMode() {
		return api.terminal.getMode({cashbox_id: this.cashboxId}).then(
			action( data => {
				if (data.code == 'OK') {
					this.cashboxMode = data.result;
				}})
		);
	}

	@action getRules() {
		// const id = this.cashboxMode == 2 ? 'cupis_rules' : 'com_rules';
		if (this.cashboxMode != 2) return false;
		const id = 'cupis_rules';
		api.html.get({id}).then(
			action(
      data => {
        if (data.code == 0) {
      	  this.cashboxRules = data.result[id];
        }
      }
      ))
	}

	@action clearRules() {
		this.cashboxRules = '';
	}

  @action setNotificationVisibility (field, value) {
    this.isNotificationVisible[field] = value;
  }
}

export default new AppStore();


// WEBPACK FOOTER //
// ./src/stores/appStore.js